import { createSlice } from '@reduxjs/toolkit';

import { getWorkspaceMatchFulfilled } from '@/api/workspace/index.ts';

export const workspaceSlice = createSlice({
  name: 'workspace',

  initialState: {
    canTrade: false,
  },

  reducers: {
    toggleWorkspaceCanTrade: (state) => {
      state.canTrade = !state.canTrade;
    },
  },

  extraReducers: (buidler) => {
    buidler.addMatcher(getWorkspaceMatchFulfilled, (state, action) => {
      if (!action.payload) {
        return;
      }
      state.canTrade = action.payload.canTrade;
    });
  },

  selectors: {
    selectWorkspaceCanTrade: ({ canTrade }) => canTrade,
  },
});

export const { toggleWorkspaceCanTrade } = workspaceSlice.actions;
export const { selectWorkspaceCanTrade } = workspaceSlice.selectors;
